// extracted by mini-css-extract-plugin
module.exports = {"icon":"style__icon__phn9l"};